import { cn } from '@/utils/cn';

interface BrandLogoProps {
  readonly className?: string;
}

/**
 * The official Bankers Fidelity mark, served as a static asset rather than inlined so it stays a single
 * cached file shared by every screen that shows it.
 */
export function BrandLogo({ className }: BrandLogoProps): React.JSX.Element {
  return (
    <img
      src="/brand/bankers-fidelity-logo.svg"
      alt="Bankers Fidelity"
      width={442}
      height={136}
      className={cn('h-10 w-auto', className)}
    />
  );
}
